<template>
  <div class="history-invoices">
    <table class="invoices-table">
      <thead>
        <tr>
          <th class="invoice-id">发票订单号</th>
          <th class="submit-date">申请日期</th>
          <th class="header-type">基本信息</th>
          <th class="invoice-header">发票抬头</th>
          <th class="invoice-type">类别</th>
          <th class="invoice-price">开票金额</th>
          <th class="balance">补缴费用</th>
          <th class="status">状态</th>
          <th class="refuse-reason">修改原因</th>
          <th class="handle-btns">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(invoice, index) in invoices" :key="index">
          <td class="invoice-id">{{ invoice.id }}</td>
          <td class="submit-date">{{ invoice.submit_date }}</td>
          <td class="header-type">{{ invoice.header_type_text }}</td>
          <td class="invoice-header">{{ invoice.invoice_header }}</td>
          <td class="invoice-type">{{ invoice.invoice_type_text }}</td>
          <td class="invoice-price">
            ¥&nbsp;{{ invoice.fixed_invoice_price }}
          </td>
          <td class="balance">¥&nbsp;{{ invoice.fixed_cash_fee }}</td>
          <td
            class="status"
            :class="{ red: invoice.status === 1 && invoice.pay_status === 1 }"
          >
            {{ invoice.status_text }}
          </td>

          <!-- 待修改才展示 -->
          <td class="refuse-reason">
            {{
              invoice.status === 1 && invoice.pay_status === 1
                ? invoice.refuse_reason
                : ""
            }}
          </td>
          <td class="handle-btns">
            <el-button
              class="cancel-now"
              v-if="invoice.pay_status === 0"
              @click="cancelNow(invoice)"
              >取消订单</el-button
            >

            <el-button
              class="pay-now"
              v-if="invoice.pay_status === 0"
              @click="payNow(invoice)"
              >立即支付</el-button
            >

            <el-button
              class="modify-now"
              v-if="invoice.status === 1 && invoice.pay_status === 1"
              @click="modifyNow(invoice, index)"
              >修改</el-button
            >

            <el-button
              class="download-now"
              v-if="invoice.status === 2"
              @click="downloadNow(invoice)"
              >下载发票</el-button
            >
            <el-button
              class="detail-now"
              v-if="invoice.status === 2"
              @click="detailNow(invoice)"
              >查看明细</el-button
            >
          </td>
        </tr>
      </tbody>
    </table>

    <!-- 修改发票 -->
    <modify-invoice-modal
      v-if="showModifyInvoiceModal && currentModifyInvoice.id"
      v-model="showModifyInvoiceModal"
      :pcds="pcds"
      :invoice="currentModifyInvoice"
      @updatedInvoice="onUpdatedInvoice"
    ></modify-invoice-modal>

    <invoice-detail-modal
      v-model="invoiceDetailModalInfo.show"
      :invoice="invoiceDetailModalInfo.invoice"
    ></invoice-detail-modal>

    <!-- 充值弹窗 -->
    <recharge-dialog
      v-model="showRechargeDialog"
      @recharge-success="visaPeerQuery"
      from="invoice"
    >
    </recharge-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import rechargeDialog from '@/components/common/recharge-dialog';

import utils from '../../../libs/utils';
import modifyInvoiceModal from './modify-invoice-modal';
import invoiceApi from '../../../api/invoice-api';
import invoiceDetailModal from './invoice-detail-modal';


export default {
  name: 'history-invoices',
  components: {
    modifyInvoiceModal,
    invoiceDetailModal,
    rechargeDialog,
  },
  props: {
    invoices: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
    pcds: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showModifyInvoiceModal: false,
      currentModifyInvoice: {}, // 当前正在修改的发票
      currentModifyInvoiceIndex: 0, // 当前正在修改的发票序号
      invoiceDetailModalInfo: {
        show: false,
        invoice: {},
      },
      showRechargeDialog: false, // 显示充值弹窗
    };
  },
  computed: {
    ...mapState('user', ['peerData']),
  },
  methods: {
    ...mapActions('user', ['visaPeerQuery']),
    // 取消发票，释放订单
    cancelNow(invoice) {
      utils.msgbox
        .confirm('确定取消该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => invoiceApi.invoiceCancel({
          order_invoice_id: invoice.id,
        }))
        .then(() => {
          utils.msg.success('操作成功！');
          this.$emit('innerUpdatedInvoice', invoice);
        })
        .catch((err) => {
          if (err.msg === '该订单已被支付' || err.msg === '该订单已被取消') {
            utils.msg.error(err.msg);
            this.$emit('innerUpdatedInvoice', invoice);
          }
        });
    },

    // 检查余额
    checkBalance(payFee) {
      return new Promise((resolve, reject) => {
        this.visaPeerQuery().then(() => {
          if (payFee > this.peerData.balance_amount) {
            this.$confirm('即将使用余额支付服务费，是否确认支付？', '提示', {
              confirmButtonText: '余额不足，请充值',
              cancelButtonText: '取消',
            }).then(() => {
              this.showRechargeDialog = true;
              reject();
            }).catch(() => {
              reject();
            });
          } else {
            this.$confirm('即将使用余额支付服务费，是否确认支付？', '提示', {
              confirmButtonText: '确认支付',
              cancelButtonText: '取消',
            }).then(() => {
              resolve();
            }).catch(() => {
              reject();
            });
          }
        });

      });
    },

    // 立即支付
    payNow(invoice) {
      // 检测发票价格是否变化
      this.checkInvoicePrice(invoice).then(() =>
        // 进入then代表没变化，可以直接使用之前的价格
        // 检测余额
        (invoice.cash_fee ? this.checkBalance(invoice.cash_fee) : Promise.resolve()),
      ).then(() => {

        invoiceApi.invoicePay({
          cash_fee: invoice.cash_fee,
          payment_type: 2,
          order_invoice_id: invoice.id,
        }).then(() => {
          // 成功就到成功页
          this.$router.replace({ name: 'payInvoiceSuccess' });
        }).catch((err) => {
          utils.msg.error(
            err && err.msg ? err.msg : '支付失败, 请重试',
          );
          this.handleRefresh(err, invoice);
        });
      });
    },

    // 检测发票的价格
    checkInvoicePrice(invoice) {
      return new Promise((resolve, reject) => {
        // 检测价格是否变化
        invoiceApi
          .invoiceCheck({
            order_invoice_id: invoice.id,
            cash_fee: invoice.cash_fee,
          })
          .then(resolve)
          .catch((err) => {
            utils.msg.error(
              err && err.msg ? err.msg : '检查发票信息失败, 请重试',
            );
            this.handleRefresh(err, invoice);
            reject(err);
          });
      });
    },

    // 处理需要刷新的场景
    handleRefresh(err, invoice) {
      setTimeout(() => {
        if (err && err.msg) {
          if (err.msg.indexOf('支付价格已变更') > -1) {
            location.reload();
            return;
          }

          if (err.msg.indexOf('该订单已被取消') > -1) {
            this.$emit('innerUpdatedInvoice', invoice);
          }
        }
      }, 2000);
    },

    // 修改
    modifyNow(invoice, index) {
      this.currentModifyInvoice = invoice;
      this.currentModifyInvoiceIndex = index;
      this.showModifyInvoiceModal = true;
    },

    // 详情
    detailNow(invoice) {
      this.invoiceDetailModalInfo.show = true;
      this.invoiceDetailModalInfo.invoice = invoice;
    },

    // 下载
    downloadNow(invoice) {
      if (!invoice || !invoice.invoice_file_set || !invoice.invoice_file_set.length) {
        return utils.msg.error('发票上传中，请稍后再试或联系客服处理');
      }

      if (invoice.invoice_file_set.length) {
        invoice.invoice_file_set.forEach((file, index) => {
          setTimeout(() => this.downloadFileAndReName(file.file_url, file.file_name), index * 1000);
        });
        return;
      }
    },

    // 下载链接并且可以自定义名称
    downloadFileAndReName(url, fileName) {
      const xhr = new XMLHttpRequest();
      xhr.open('get', url, true);
      xhr.responseType = 'blob';
      xhr.onload = function () {
        if (xhr.status === 200) {
          const localURL = window.URL.createObjectURL(xhr.response);
          const a = document.createElement('a');
          a.href = localURL;
          a.setAttribute('download', fileName || new Date().getTime());
          a.click();
        }
      };
      xhr.send();
    },
    // 发票跟新完成
    onUpdatedInvoice(invoice) {
      this.$emit('innerUpdatedInvoice', invoice);
    },
  },
  
};
</script>

<style lang="less" scoped>
.history-invoices {
  display: flex;
  width: 100%;
  .invoices-table {
    width: 100%;
    border-spacing: 0;
    thead {
      background: #fafbfc;
      border: 1px solid #e9eef2;
      tr {
        height: 60px;
        th {
          font-size: 14px;
          font-weight: 500;
          color: #2f333d;
          line-height: 20px;
        }
      }
    }
    tbody {
      tr {
        td {
          border-bottom: 1px solid #e9eef2;
          font-size: 14px;
          font-weight: 400;
          color: #2f333d;
          line-height: 20px;
          padding: 24px 0;
          /deep/ .el-button {
            border-radius: 2px;
            width: 88px;
            height: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            display: inline-block;
            &:hover {
              opacity: 0.9;
            }
            &.cancel-now {
              color: #333;
              background-color: white;
              border: 1px solid #c0c3c5;
              width: 88px;
            }
            &.pay-now {
              background: #ff8033;
              color: #fff;
              border: 1px solid #ff8033;
            }
            &.modify-now {
              color: #ff6464;
              border: 1px solid #ff6464;
            }
            &.download-now {
              color: #599fff;
              border: 1px solid #599fff;
            }
            &.detail-now {
              color: #599fff;
              border: 1px solid #599fff;
            }
          }
        }
      }
    }
    .invoice-id{
      width: 60px;
      text-align: left;
      padding-left: 17px;
    }
    .submit-date {
      width: 90px;
      text-align: left;
      padding-left: 17px;
    }
    .header-type {
      text-align: left;
      padding-left: 24px;
      width: 80px;
    }
    .invoice-header {
      padding-left: 24px;
      text-align: left;
      width: 180px;
      word-break: break-all;
    }
    .invoice-type {
      padding-left: 24px;
      text-align: left;
      width: 60px;
    }
    .invoice-price {
      padding-left: 24px;
      text-align: right;
      width: 90px;
    }
    .balance {
      padding-left: 24px;
      text-align: right;
      width: 100px;
    }
    .status {
      padding-left: 24px;
      text-align: center;
      width: 70px;
      &.red {
        color: #ff6464;
      }
    }
    .refuse-reason {
      flex: 1;
      text-align: center;
      padding-left: 24px;
      word-break: break-all;
    }
    .handle-btns {
      flex: 1;
      text-align: center;
      width: 195px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/invoice-manage/components/history-invoices.vue